module.exports = __webpack_public_path__ + "static/media/bazar-blot-logo.00b1d6d7.png";